// @flow
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import HeaderBlock from './HeaderBlock';
import MerchantRegistrations from './MerchantRegistrations';
import MerchantTransaction from './MerchantTransaction';
import DirectMerchantShow from './DirectMerchants/DirectMerchantsShow';
import DirectMerchantsIndex from './DirectMerchants/DirectMerchantsIndex';
import { MerchantsDiv, CustomPageHeaderP } from './MerchantsStyles';
import { PageHeaderDiv, Subheaderh4 } from '../../components/PageHeaderStyles';
import { Default } from '../../components/Responsive';
import { connect } from 'react-redux';
import FailedMerchantRegistrationsMessage from './FailedMerchantRegistrationsMessage';

type Props = {
  location: {
    pathname: string
  },
  hasFailedMerchantRegistrations: boolean
};

class Merchants extends Component<Props> {
  headerBlock = (text: string, subHeader?: string) => (
    <MerchantsDiv>
      <PageHeaderDiv>
        <CustomPageHeaderP>{text}</CustomPageHeaderP>
        <Default>
          <Subheaderh4>{subHeader}</Subheaderh4>
        </Default>
      </PageHeaderDiv>
      {this.props.hasFailedMerchantRegistrations && (
        <FailedMerchantRegistrationsMessage />
      )}
    </MerchantsDiv>
  );

  directMerchants = (Component: any, props: {} = {}) => {
    const text =
      'Get a quick overview and track the progress of all the merchants you have referred directly, in the table below. To view your commission earned for each partner, click on the row to open up a more detailed view.';
    const subHeader = 'Referred Direct Merchants';
    return (
      <>
        {this.headerBlock(text, subHeader)}
        <Component {...props} />
      </>
    );
  };

  handleDirectMerchantsIndex = () => this.directMerchants(DirectMerchantsIndex);

  handleDirectMerchantsShow = (props: {}) =>
    this.directMerchants(DirectMerchantShow, props);

  handleMerchantsTransactions = () => {
    const text =
      'View a history of all transactions processed by merchants you have referred. Check the transaction sum, fees, status and commission earned for each transaction.';
    const subHeader = 'All Transactions';
    return (
      <>
        {this.headerBlock(text, subHeader)}
        <MerchantTransaction />
      </>
    );
  };

  render() {
    return (
      <>
        <HeaderBlock path={this.props.location.pathname} />
        <Switch>
          <Route
            exact
            path="/merchants"
            render={() => this.handleDirectMerchantsIndex()}
          />
          <Route
            exact
            path="/merchants/transactions"
            render={() => this.handleMerchantsTransactions()}
          />
          <Route
            path="/merchants/registrations/:method?"
            component={MerchantRegistrations}
          />
          <Route
            exact
            path="/merchants/:id"
            render={props => this.handleDirectMerchantsShow(props)}
          />
        </Switch>
      </>
    );
  }
}

const mapStateToProps = state => ({
  hasFailedMerchantRegistrations:
    state.merchants.directMerchants.index.directMerchants
      .has_failed_merchant_registrations
});

export default connect(mapStateToProps)(Merchants);
